/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The diaper clock of one child flagged "uses diapers" and checked in: minutes since the last toilet entry or the check-in, and its state.
 */
export type shifts_LiveDiaperCheckDTO = {
    child_id: string;
    child_name: string;
    /**
     * DueAt is when the check falls due; null while the child is asleep.
     */
    due_at: string | null;
    /**
     * SinceMinutes are the minutes since the last toilet entry or the check-in.
     */
    since_minutes: number;
    /**
     * State: ok (under 75 % of the threshold), due_soon, overdue (the group lead is told),
     * escalated (the lead's head is told), paused (the child is asleep).
     */
    state: shifts_LiveDiaperCheckDTO.state;
};
export namespace shifts_LiveDiaperCheckDTO {
    /**
     * State: ok (under 75 % of the threshold), due_soon, overdue (the group lead is told),
     * escalated (the lead's head is told), paused (the child is asleep).
     */
    export enum state {
        OK = 'ok',
        DUE_SOON = 'due_soon',
        OVERDUE = 'overdue',
        ESCALATED = 'escalated',
        PAUSED = 'paused',
    }
}

